import React from 'react';
import * as P from 'prop-types';
import { TextField } from '@material-ui/core';
import { textFieldType, textFieldSize } from '../Common';

function City({
  value, handleChange, handleBlur, disabled, prefix, error,
}) {
  return (
    <TextField
      fullWidth
      size={textFieldSize}
      value={value}
      disabled={disabled}
      onChange={handleChange}
      onBlur={handleBlur}
      label="Cidade"
      error={!!error}
      helperText={error}
      variant={textFieldType}
      name={`${prefix}[city]`}
    />
  );
}

City.propTypes = {
  value: P.string,
  handleChange: P.func.isRequired,
  handleBlur: P.func.isRequired,
  disabled: P.bool,
  prefix: P.string.isRequired,
  error: P.string,
};

City.defaultProps = {
  value: '',
  error: '',
  disabled: false,
};

export default React.memo(City);
